/* eslint-disable max-len */
/* eslint-disable no-template-curly-in-string */
export default {
    'where this flow will be accessible from': 'A trusted list of regions from which a user can join, launch, or use this flow.',
    'where this flow can be executed': 'A trusted list of regional platform instances that are allowed to execute this flow.',
    'where flows in this tenant are accessible from': 'A trusted list of regions from which a user can join, launch, or use a flow.',
    'where flows in this tenant can be executed': 'A trusted list of regional platform instances that are allowed to execute a flow.',
    'enter new flow builder details': 'Please enter the details below to provision a new Flow Builder user account.',
    'unsaved changes warning': 'Are you sure you want to leave Boomi Flow? Any un-saved changes will be lost',
    'cannot initialize flow': 'The flow could not be initialized',
    'copy map element': 'Copy (Ctrl+Alt+C / Ctrl+Opt+C)',
    'paste map element': 'Paste (Ctrl+Alt+V / Ctrl+Opt+V)',
    'reset outcome': 'Reset Position',
    'open subflow': 'Open Subflow in New Tab',
    'map element dupe error message': 'There was an error duplicating this map element',
    'copy start-outcome error': 'You cannot copy the Start element or outcomes to the clipboard',
    'empty clipboard': 'There are no map elements copied to your clipboard',
    'docs linktext': 'Documentation',
    'docs summarytext': 'Read the official documentation for all current features.',
    'support linktext': 'Support',
    'support summarytext': 'Open a support case to resolve issues and get answers.',
    'community linktext': 'Community',
    'community summarytext': 'Ask questions, share knowledge, and join groups with other users.',
    'training linktext': 'Training',
    'training summarytext': 'Develop core competencies as part of Boomi\'s certification paths.',
    'help buttontext': 'Help',
    'integration linktext': 'Integration',
    'integration summarytext': 'Build processes that transform and integrate data between systems.',
    'datahub linktext': 'Master Data Hub',
    'datahub summarytext': 'Synchronize, cleanse, match, and enrich trusted data across domains.',
    'apimgnt linktext': 'API Management',
    'apimgnt summarytext': 'Manage and control the usage of APIs throughout their lifecycle.',
    'appswitcher buttontext': 'Services',
    'settings buttontext': 'Settings',
    'organization linktext': 'Organization',
    'organization summarytext': 'Manage your Flow organization.',
    'tenant linktext': 'Tenant',
    'tenant summarytext': 'Edit tenant settings, security, users.',
    'logout text': 'Sign Out',
    'page save success': 'Page saved successfully',
    'migration timed out 1': 'The current migration of data to the store "${store}" in the Tenant has not provided us with an update since ${lastUpdated}.',
    'migration timed out 2': 'Because this is over 30 minutes ago, this indicates that the process may have failed.',
    'migration timed out 3': 'To allow you to continue with other migrations, you are now able to migrate and change the External Storage settings for this Tenant.',
    'migration success': 'The migration of data to "${store}" has completed successfully',
    'migration failure 1': 'The migration of data to the store "${store}" in the Tenant has failed.',
    'migration failure 2': 'Check your email for more details.',
    'confirm import title': 'Confirm Import',
    'confirm import message': 'Are you sure you want to import a flow into your tenant: ${tenant}?',
    'confirm import message with flow name': 'Are you sure you want to import the flow "${flowName}" into your tenant: ${tenant}?',

    'confirm overwrite title': 'Overwrite existing elements?',
    'confirm overwrite body 1': 'We have detected that this Flow will import some shared elements that already exist in this Tenant.',
    'confirm overwrite body 2': 'This can happen if you\'ve already installed this Flow and are now reinstalling without having deleted all Values, Types, Services etc. that the Flow had previously imported.',
    'confirm overwrite body 3': 'If you continue, these elements will be overwritten and any changes you\'ve made to these elements will be undone.',
    'confirm overwrite body 4': 'Are you sure you wish to continue?',

    'no notifications': 'You have not received any notifications',

    // eslint-disable-next-line no-template-curly-in-string
    'unsupported map element error': '"${elementType}" is an unsupported map element type',

    'subflow heading': 'Subflow',
    'subflow select label': 'Select a flow to run as a subflow',
    'subflow select placeholder': 'Select a subflow',
    'subflow save': 'Save Subflow',
    'subflow cancel': 'Cancel',
    'group heading': 'Group',
    'confirm delete group element': 'Delete the "${developerName}" ${elementType}?',
    'delete group element dependencies': 'This will also delete the following elements within the ${elementType}:',
    'delete heading': 'Delete ${elementType}',
    'delete button': 'Delete',
    'group save': 'Save Group',
    'cancel button': 'Cancel',
    'getting started surtitle': 'Getting Started',
    'getting started title': 'Welcome to Boomi Flow!',
    'getting started message': 'Get started by creating a new Flow from scratch or browse the Flow Library to start with a Flow template.',
    FL_title: 'Flow Library',
    FL_subtitle: 'Get a head start on your next project with resources from the Flow Library. Browse and install example flows, page templates and players.',
    FL_layout_grid: ' Grid',
    FL_layout_list: ' List',
    FL_no_results: 'No Results',
    FL_by_author: 'by ${author}',
    FL_heading_type: 'Type',
    FL_heading_published: 'Published',
    FL_heading_installs: 'Installs',
    FL_badge_new: 'New',
    FL_button_view: 'View',
    FL_button_install: ' Install',
    VS_duplicate_value_1: 'A Value already exists with the name "${value}".',
    VS_duplicate_value_2: 'Are you sure you want to make a new Value with the same name?',
    VS_select_button_text: 'Select or create a new ${element}',
    VS_loading_text: 'Loading...',
    SF_no_matching_values_text: 'There are no values to match. Try importing values accepted by the subflow into the parent flow.',
    AV_private_access_value: 'No external access',
    AV_input_access_value: 'Value can be initialized when the flow starts',
    AV_output_access_value: 'Value is returned from the flow',
    AV_input_output_access_value: 'Value is set as both',
    AV_public_access_value: 'Value is automatically passed to and from subflows',
    SC_config_refresh_failed: 'There was the following error contacting the service for configuration values:',
    SC_delete_service_1: 'Are you sure you want to delete the Service "${serviceName}"?',
    SC_successful_delete: 'The Service "${serviceName}" was successfully deleted',
    SAML_warning: 'You are currently logged in using SSO, so before making changes to your SSO configuration, please ensure you can still authenticate using your standard username/password credentials to prevent accidental lockouts.',
    SAML_enable_label: 'Enable SAML Single Sign-On',
    SAML_certificate_label: 'Certificate',
    SAML_certificate_help: 'A PEM-encoded public X.509 certificate that will be used by Flow to validate SAML messages.',
    SAML_redirect_url_label: 'Redirect URI',
    SAML_redirect_url_help: 'The URI to redirect users to in order for them to authenticate in the IDP.',
    SAML_login_url_label: 'Flow Login URL',
    SAML_login_url_help: 'The URL that SSO users will use to log into Flow. When using this URL, users will only be able to log into this tenant.',
    SAML_logout_url_label: 'Logout Redirect URI',
    SAML_firstname_label: 'First Name Claim Attribute Name',
    SAML_firstname_help: 'If the SAML assertion generated by your IDP does not include the following claim attribute names, then you may optionally add a custom name: "first_name", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname", "User.FirstName", "givenName".',
    SAML_lastname_label: 'Last Name Claim Attribute Name',
    SAML_lastname_help: 'If the SAML assertion generated by your IDP does not include the following claim attribute names, then you may optionally add a custom name: "last_name", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname", "User.LastName", "sn".',
    SAML_email_label: 'Email Address Claim Attribute Name',
    SAML_email_help: 'If the SAML assertion generated by your IDP does not include the following claim attribute names, then you may optionally add a custom name: "User.email", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress", "email".',
    SAML_groupname_label: 'Group Claim Attribute Name',
    SAML_groupname_help: 'If you wish to restrict tenant access based on groups in your IDP, then add the claim attribute name that references groups inside the SAML assertion.',
    SAML_groups_label: 'Groups',
    SAML_groups_help: 'If you wish to restrict tenant access based on groups in your IDP, then add each group. A user must be a member of at least one of these groups to be authorized to access the tenant.',

    FORG_title: 'Organizations',
    FORG_subtitle: 'Manage organization...',
    FORG_not_joined_tenant_title: 'Tenant Invitations',
    FORG_leave_confirmation_title: 'Leave Organization',
    FORG_leave_confirmation: 'Are you sure you want to leave this organization?',
    FORG_left_confirmation: '${user} successfully left the organization',
    FORG_invite_tenant_title: 'Invite a tenant',
    FORG_invite_user_title: 'Invite a user to become an administrator of this organization',
    FORG_provision_title: 'Create Tenant',
    FORG_provision_description_1: 'Create a new Tenant within this organization.',
    FORG_provision_description_2: 'A user needs to be added to the Tenant.',
    FORG_provision_description_3: 'If the user doesn\'t have an account this will start the process of provisioning a new account for that email address.',
    FORG_tenant_user_provisioned: 'Your new tenant has been provisioned.',
    FORG_remove_tenant_title: 'Remove Tenant',
    FORG_remove_tenant_message: 'Are you sure you want to remove ${name} from this organization?',
    FORG_remove_user_title: 'Remove User',
    FORG_remove_user_message: 'Are you sure you want to remove ${name} from this organization?',
    FORG_tenant_invitations_description: 'Invitations sent to your tenant. Accept an invitation to add your tenant into the requesting Organization.',
    FORG_user_invitations_description: 'Invitations sent to your user account. Accept an invitation to add your user account into the requesting Organization.',

    'tenant renaming subtenant warning': 'Renaming this tenant will also rename all subtenants to match.',
    'tenant renaming help text': 'A tenant name can only consist of alphanumeric characters (a-z, A-Z, 0-9) and hyphens (-).',
    'edit page with none selected': 'Please select or create a page before editing',
    PAGE_COND_BASIC_value_of: 'When the value of ',
    PAGE_COND_BASIC_create_success: 'Page condition successfully created!',
    PAGE_COND_BASIC_error_unsaved_page: 'You must make sure you have saved this page before creating basic page conditions',
    PAGE_COND_BASIC_error_validation: 'Please make sure you have selected all required fields',
    PAGE_COND_BASIC_save: 'Save Basic Condition',
    PAGE_COND_BASIC_error_no_components: 'You must create some page components with either boolean or scalar values.',
    PAGE_COND_BASIC_title: 'Create a Basic Condition',
    PAGE_COND_BASIC_instructions_1: 'Create a condition to change the state of a component in the page layout based on the value of another component',
    PAGE_COND_BASIC_instructions_2: 'To view, edit and delete page conditions use the',
    PAGE_COND_BASIC_instructions_3: 'Advanced Page Conditions Editor',

    PAGE_CONFIG_save_hidden_inputs_label: 'Save Hidden Inputs',
    PAGE_CONFIG_save_hidden_inputs_help_text: 'Enable hidden components to save content value to state',

    FLOW_delete_confirmation_title: 'Delete Flow',
    FLOW_unable_to_delete: 'Unable to delete flow: ${flowName}',
    FLOW_delete_confirmation_message: 'Are you sure you want to delete the "${flowName}" flow?',

    AUTH_welcome: 'Welcome! Sign in to Flow',
    AUTH_email_address: 'Email Address',
    AUTH_no_account: `Don't have an account? `,
    AUTH_free_trial: 'Sign up for a free trial.',
    AUTH_platform_status: 'Platform status',
    AUTH_reset_sent: 'If the email address you entered: {0} is associated with your user account, we sent you an email with a link to reset your password. The link expires in 1 hour.',
    AUTH_login_failed: `You're sign in information is incorrect. Enter the email address and password associated with your user account.`,

    GENERAL_cannot_be_undone: 'This cannot be undone.',

    SIDE_MENU_TITLE: 'Menu',

    LOCAL_RUNTIME_title: 'Local Runtimes',
    LOCAL_RUNTIME_summary: 'Local runtimes allow you to run Flows on your own infrastructure.',
    LOCAL_RUNTIME_create_screen_h2: 'Setup Your Local Runtime Environment',
    LOCAL_RUNTIME_create_screen_h2_summary: 'Before you create a local runtime connection make sure to setup a Flow runtime on your own infrastructure.',
    LOCAL_RUNTIME_create_screen_h3: 'Configure Your Connection',
    LOCAL_RUNTIME_create_screen_h3_summary: 'Give your connection a name and select any tenants that you would like to share this connection with.',
    LOCAL_RUNTIME_create_screen_connection: 'Connection',
    LOCAL_RUNTIME_create_screen_shared_tenants: 'Shared Tenants',
    LOCAL_RUNTIME_create_screen_shared_tenants_summary: 'You may share this local runtime connection with your other Flow tenants and allow those other tenants to deploy Flows directly to this local environment.',
    LOCAL_RUNTIME_create_screen_submit: 'Create New Local Runtime Connection',
    LOCAL_RUNTIME_create_screen_cancel: 'Cancel',

    LOCAL_RUNTIME_edit_screen_h2: 'Edit Your Connection',
    LOCAL_RUNTIME_edit_screen_submit: 'Save and Close',
    LOCAL_RUNTIME_create_screen_number_tenants_selected_summary: 'Select Tenants below to share the runtime with.',
    LOCAL_RUNTIME_create_screen_number_tenants_selected: '${tenantsSelected} Selected',
    LOCAL_RUNTIME_token_display_warning: 'Use the server key generated below to connect your local Flow runtime to the Flow cloud. The token will expire 24 hours after generation. Make sure to copy the token before closing this page. If you lose this token you will have to delete the local runtime connection and create a new one.',
    LOCAL_RUNTIME_token_display_submit: 'Done',
    LOCAL_RUNTIME_token_display_h2: 'This is Your Server Key',
    LOCAL_RUNTIME_delete_modal_title: 'Delete Local Runtime Connection',
    LOCAL_RUNTIME_delete_modal_message: 'Are you sure you want to delete the ${connectionName} connection?',
    LOCAL_RUNTIME_publish_to_local_runtime_version_warning: 'Current runtime version is ${version}, we highly recommend to always use the latest version, learn more in our Documentation.',

    TENANT_user_description: 'Users can be added to tenants and subtenants as required, allowing other people in your tenant to sign in to a tenant and access the flows and content within.',
    TENANT_subtenant_description: 'You can use subtenants to organize your flows. For example, use separate subtenants for business units like HR and Finance. Subtenants can also align to a development cycle, for example, you can create subtenants for Development, Staging, and Production environments.',
    TENANT_security_description: 'Set access restrictions by IP address and IP ranges.',
    TENANT_sso_description: 'Restrict access to this tenant to users authenticating with single sign-on.',
    TENANT_reporting_description: 'Flow has a reporting infrastructure, that lets you analyze, store, and query state data from your own database or analytics user interface.',
    TENANT_restrictions_description: 'Set restrictions on who can access a flow and where flows are executed.',
    TENANT_remove_confirmation_title: 'Remove User',
    TENANT_remove_confirmation_message: 'Are you sure you want to remove the user ${firstName} ${lastName}, ${email}?',
    TENANT_update_role_title: 'Change user role?',
    TENANT_update_role_message: 'Are you sure you want to update the user ${email}, from ${currentRole} to ${newRole}? Changing a role will change the access and privileges assigned to a user.',
    TENANT_observability_description: 'Send runtime trace data for flows to an OpenTelemetry Protocol (OTLP) endpoint using the OpenTelemetry standard, allowing you to troubleshoot, debug, and manage flow runtime performance. Data can be sent directly to an application performance monitoring system (APM) that supports direct OTLP ingestion, or to an OpenTelemetry Collector managed by your Organization.',

    OTLP_endpoint_label: 'Otlp Endpoint',
    OTLP_endpoint_help: 'OpenTelemetry Protocol (OTLP) endpoint to send data to. Only RPC over HTTPS (Remote Procedure Call over HTTPS) endpoints are supported.',

    OTLP_headers_label: 'Otlp Headers',
    OTLP_headers_help: 'Optional list of headers to send with the data, such as credentials for authentication to the APM. Multiple headers must be comma-separated, for example “name1=value1,name2=value2”.',

    MACRO_delete_confirmation_title: 'Delete Macro',
    MACRO_delete_confirmation_message: 'Are you sure you want to delete the "${macroName}" macro?',

    PLAYER_delete_confirmation_title: 'Delete Player',
    PLAYER_delete_confirmation_message: 'Are you sure you want to delete the "${playerName}" player?',

    copy_platform_key_title: 'Copy Platform Key to clipboard',
    copy_saml_login_url_title: 'Copy Flow login URL to clipboard',
    copy_server_key_title: 'Copy Server Key to clipboard',

    USER_api_key_description: 'You can authenticate with the Boomi Flow API using an API Key. Once you have generated an API Key, add a x-boomi-flow-api-key header to your API requests instead of an Authorization header, to authenticate as yourself. This header should contain only the apiKey value of the Flow API Key.',
    USER_api_key_validation_message: 'A key name and a selected Tenant must be provided to generate a key',
    USER_api_key_remove_confirm_title: 'Are you sure you want to delete this key?', 
    USER_api_key_remove_confirm_message: 'Any future requests that use this key will be not be authenticated.',

    GRAPH_config_panel_save: 'Save',
    GRAPH_config_panel_cancel: 'Cancel',
    GRAPH_action_edit: 'Edit',
    GRAPH_action_edit_metadata: 'Edit Metadata',
    GRAPH_action_copy: 'Copy',
    GRAPH_action_paste: 'Paste',
    GRAPH_action_delete: 'Delete',

    create_group_parents_error: 'Cannot create a group because some selected elements are in different groups or swimlanes',

    SWIMLANE_CONFIG_heading: 'Swimlane:',
    SWIMLANE_CONFIG_name_label: 'Name',
    SWIMLANE_CONFIG_name_validation_message: 'You must provide a name',
    SWIMLANE_CONFIG_auth_type_label: 'What type of user authentication should be used?',
    SWIMLANE_CONFIG_auth_type_validation_message: 'You must select an authentication type',
    SWIMLANE_CONFIG_social_feed_label: 'Social feed for collaboration',
    SWIMLANE_CONFIG_social_feed_validation_message: 'You must select whether to add a social feed',
    SWIMLANE_CONFIG_comment_label: 'Comments about this Swimlane',
    SWIMLANE_CONFIG_services_label: 'Which Service will users authenticate with?',
    SWIMLANE_CONFIG_services_validation_message: 'You must select a service',
    SWIMLANE_CONFIG_cancel_button_text: 'Cancel',
    SWIMLANE_CONFIG_save_button_text: 'Save Swimlane',


};
